import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Send, XCircle, Trash2, ArrowLeft, RefreshCw, Loader2 } from 'lucide-react';
import { listSessions, sendMessage, endSession, wipeAllSessions } from '../api/chatApi';

export default function AdminChatPage() {
  const [sessions, setSessions] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [adminPass, setAdminPass] = useState('');
const [authenticated, setAuthenticated] = useState(false);
  const refresh = useCallback(async () => {
    try {
      const list = await listSessions();
      setSessions(list || []);
      // If active was deleted, reset
      if (activeId && list && !list.find((s) => s.id === activeId)) {
        setActiveId(null);
      }
    } catch (e) {
      setError('Could not load sessions.');
    }
  }, [activeId]);

  // Poll every 2s
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 2000);
    return () => clearInterval(t);
  }, [refresh]);

  const active = activeId ? sessions.find((s) => s.id === activeId) : null;

  const onReply = async (e) => {
    e.preventDefault();
    if (!draft.trim() || !active || busy) return;
    const text = draft.trim();
    setDraft('');
    setBusy(true); setError('');
    try {
      await sendMessage(active.id, 'owner', text);
      await refresh();
    } catch (err) {
      setError('Could not send.');
      setDraft(text);
    } finally {
      setBusy(false);
    }
  };

  const onEnd = async () => {
    if (!active) return;
    if (!window.confirm('End this chat and delete all messages forever?')) return;
    setBusy(true); setError('');
    try {
      await endSession(active.id);
      setActiveId(null);
      await refresh();
    } catch (err) {
      setError('Could not end chat.');
    } finally {
      setBusy(false);
    }
  };

  const onWipeAll = async () => {
    if (!window.confirm('Wipe ALL chat threads forever? This cannot be undone.')) return;
    setBusy(true); setError('');
    try {
      await wipeAllSessions();
      setActiveId(null);
      await refresh();
    } catch (err) {
      setError('Could not wipe.');
    } finally {
      setBusy(false);
    }
  };
if (!authenticated) {
  return (
    <div style={{ minHeight: '100vh', background: '#000', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ width: '320px' }}>
        <input
          type="password"
          placeholder="Admin Password"
          value={adminPass}
          onChange={(e) => setAdminPass(e.target.value)}
          style={{ width: '100%', padding: '14px', marginBottom: '12px', background: '#111', color: 'white', border: '1px solid #333' }}
        />
        <button
          onClick={() => {
            if (adminPass === 'likithadmin123') {
              setAuthenticated(true);
            } else {
              alert('Wrong Password');
            }
          }}
          style={{ width: '100%', padding: '14px', background: 'white', color: 'black' }}
        >
          Login
        </button>
      </div>
    </div>
  );
}
  return (
    <div style={{ minHeight: '100vh', position: 'relative', zIndex: 3, padding: '120px 96px 80px' }} className="admin-shell">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28, gap: 16, flexWrap: 'wrap' }}>
        <Link to="/" className="mono" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 11, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.55)', textTransform: 'uppercase', textDecoration: 'none' }}>
          <ArrowLeft size={12} /> Back to home
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.4)' }}>
            ADMIN &middot; {sessions.length} active
          </span>
          <button onClick={refresh} className="btn-ghost" style={{ padding: '8px 12px', fontSize: 10 }} disabled={busy}>
            <RefreshCw size={12} style={{ marginRight: 6, verticalAlign: '-2px' }} /> Refresh
          </button>
          <button onClick={onWipeAll} className="btn-ghost" style={{ padding: '8px 14px', fontSize: 10 }} disabled={busy}>
            <Trash2 size={12} style={{ marginRight: 6, verticalAlign: '-2px' }} /> Wipe all
          </button>
        </div>
      </div>

      <div className="section-label" style={{ marginBottom: 12 }}>09 &mdash; Owner inbox</div>
      <h1 className="section-title" style={{ margin: 0 }}>Chat threads</h1>
      <p style={{ color: 'rgba(245,245,245,0.55)', fontSize: 14, lineHeight: 1.7, marginTop: 14, maxWidth: 640 }}>
        Live, cross-device chat backed by FastAPI + MongoDB. Reply to visitors here —
        click <strong style={{ color: '#f5f5f5' }}>End chat</strong> to permanently delete a thread.
      </p>
      {error && <div style={{ marginTop: 12, color: '#ff8a8a', fontSize: 12 }}>{error}</div>}

      <div className="admin-grid" style={{ marginTop: 36, display: 'grid', gridTemplateColumns: '320px minmax(0, 1fr)', gap: 24, minHeight: 520 }}>
        {/* Sessions list */}
        <div className="glass-card" style={{ padding: 14, height: 600, overflowY: 'auto' }}>
          {sessions.length === 0 && (
            <div style={{ color: 'rgba(245,245,245,0.45)', fontSize: 13, padding: 20, textAlign: 'center' }}>
              No active threads.
            </div>
          )}
          {sessions.map((s) => {
            const last = s.messages && s.messages.length ? s.messages[s.messages.length - 1].text : 'No messages yet';
            return (
              <div
                key={s.id}
                onClick={() => setActiveId(s.id)}
                style={{
                  padding: 14,
                  borderRadius: 10,
                  background: activeId === s.id ? 'rgba(245,245,245,0.06)' : 'transparent',
                  border: activeId === s.id ? '1px solid rgba(245,245,245,0.18)' : '1px solid transparent',
                  cursor: 'pointer',
                  marginBottom: 6,
                  transition: 'background 180ms ease, border-color 180ms ease',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 16, fontWeight: 500 }}>{s.name}</div>
                  <div className="mono" style={{ fontSize: 9, letterSpacing: '0.2em', color: 'rgba(245,245,245,0.4)' }}>
                    {s.createdAt ? new Date(s.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                  </div>
                </div>
                <div style={{ marginTop: 6, color: 'rgba(245,245,245,0.55)', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {last}
                </div>
              </div>
            );
          })}
        </div>

        {/* Active thread */}
        <div className="glass-card" style={{ display: 'flex', flexDirection: 'column', height: 600 }}>
          {active ? (
            <>
              <div className="chat-header" style={{ borderBottom: '1px solid rgba(245,245,245,0.08)' }}>
                <div>
                  <div className="mono" style={{ fontSize: 9, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>
                    Thread
                  </div>
                  <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 18, marginTop: 2 }}>{active.name}</div>
                </div>
                <button onClick={onEnd} className="btn-ghost" style={{ padding: '8px 14px', fontSize: 10, display: 'inline-flex', alignItems: 'center', gap: 6 }} disabled={busy}>
                  <XCircle size={12} /> End chat
                </button>
              </div>
              <div className="chat-body" style={{ flex: 1 }}>
                {(!active.messages || active.messages.length === 0) && (
                  <div className="bubble system">No messages yet</div>
                )}
                {(active.messages || []).map((m) => (
                  <div key={m.id} className={`bubble ${m.sender === 'owner' ? 'me' : 'them'}`}>
                    {m.text}
                  </div>
                ))}
              </div>
              <form onSubmit={onReply} className="chat-form">
                <input
                  value={draft}
                  onChange={(e) => setDraft(e.target.value)}
                  placeholder="Reply…"
                  disabled={busy}
                />
                <button type="submit" aria-label="Send" disabled={busy}>
                  {busy ? <Loader2 size={14} className="spin" /> : <Send size={14} />}
                </button>
              </form>
            </>
          ) : (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(245,245,245,0.45)', fontSize: 14 }}>
              Select a thread to reply
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
